import { render, staticRenderFns } from "./ApprovalCommonData.vue?vue&type=template&id=4b6d121c"
import script from "./ApprovalCommonData.vue?vue&type=script&lang=js"
export * from "./ApprovalCommonData.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCommonData.vue?vue&type=style&index=0&id=4b6d121c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports